import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Calling from '../../api/Calling';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import User_Navbar from './User_Navbar';
import formatDate from '../../components/formatDate';
import MainButton from '../../components/ul/MainButton';
import { FaUser } from 'react-icons/fa6';
import generateCaptcha from '../../components/captcha';
import { FaArrowLeft, FaArrowRight, FaSortAmountDownAlt, FaSortAmountUp } from 'react-icons/fa';
import { IoMdSearch } from 'react-icons/io';
import DeleteButton from '../../components/ul/DeleteButton';
import { MdDeleteSweep } from 'react-icons/md';
import NotFound from '../../components/ul/NotFound';
import getISTDate from '../../components/getISTDate';
import { FiUsers } from 'react-icons/fi';


const AllUserLogin = () => {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [sortOrder, setSortOrder] = useState(-1);
    const [selectAll, setSelectAll] = useState(false);
    const [startDate, setStartDate] = useState(getISTDate());
    const [endDate, setEndDate] = useState(getISTDate());
    const [totalUser, setTotalUser] = useState(0);
    const [selectState, setSelectState] = useState('today');
    const limit = 100; // Items per page
    // Fetch data from API
    const fetchData = async () => {
        setLoader(true);
        try {
            const response = await Calling.getAllUserLogin(currentPage, startDate, endDate, limit, search, sortOrder);
            if (response?.status) {
                setData(response?.data);
                setTotalPages(response?.totalPage);
                setTotalUser(response?.totalRecord);
            } else {
                toast.error(response?.message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoader(false);
        }
    };
    // Fetch data from API
    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, [currentPage, sortOrder, startDate, endDate]);

    const handleSelectAll = () => {
        if (!selectAll) {
            const allUserIds = data.map((user) => user._id);
            setSelectedUsers(allUserIds);
        } else {
            setSelectedUsers([]);
        }
        setSelectAll(!selectAll);
    };

    const handleSelectUser = (id) => {
        if (selectedUsers.includes(id)) {
            setSelectedUsers(selectedUsers.filter((userId) => userId !== id));
        } else {
            setSelectedUsers([...selectedUsers, id]);
        }
    };

    const handleDateRangeFilter = (range) => {
        const todayUTC = new Date();

        // Helper to convert any date to IST and return YYYY-MM-DD
        const toIST = (date) => {
            const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
            const istDate = new Date(date.getTime() + istOffset);
            return istDate.toISOString().split('T')[0];
        };

        let start, end;

        switch (range) {
            case 'today':
                start = toIST(todayUTC);
                end = start;
                setSelectState('today');
                break;

            case 'yesterday':
                const yesterdayUTC = new Date(todayUTC);
                yesterdayUTC.setDate(todayUTC.getDate() - 1);
                start = toIST(yesterdayUTC);
                end = start;
                setSelectState('yesterday');
                break;

            case 'thisWeek':
                const firstDayOfWeekUTC = new Date(todayUTC);
                firstDayOfWeekUTC.setDate(todayUTC.getDate() - todayUTC.getDay());
                const lastDayOfWeekUTC = new Date(firstDayOfWeekUTC);
                lastDayOfWeekUTC.setDate(firstDayOfWeekUTC.getDate() + 6);
                start = toIST(firstDayOfWeekUTC);
                end = toIST(lastDayOfWeekUTC);
                setSelectState('thisWeek');
                break;

            case 'thisMonth':
                const firstDayOfMonthUTC = new Date(todayUTC.getFullYear(), todayUTC.getMonth(), 1);
                const lastDayOfMonthUTC = new Date(todayUTC.getFullYear(), todayUTC.getMonth() + 1, 0);
                start = toIST(firstDayOfMonthUTC);
                end = toIST(lastDayOfMonthUTC);
                setSelectState('thisMonth');
                break;

            case 'last6Months':
                const firstDayLast6UTC = new Date(todayUTC.getFullYear(), todayUTC.getMonth() - 5, 1);
                const lastDayLast6UTC = new Date(todayUTC.getFullYear(), todayUTC.getMonth() + 1, 0);
                start = toIST(firstDayLast6UTC);
                end = toIST(lastDayLast6UTC);
                setSelectState('last6Months');
                break;

            case 'thisYear':
                const firstDayOfYearUTC = new Date(todayUTC.getFullYear(), 0, 1);
                const lastDayOfYearUTC = new Date(todayUTC.getFullYear(), 11, 31);
                start = toIST(firstDayOfYearUTC);
                end = toIST(lastDayOfYearUTC);
                setSelectState('thisYear');
                break;

            default:
                start = '';
                end = '';
                setSelectState('range');
        }

        setStartDate(start);
        setEndDate(end);
        setCurrentPage(1); // Reset page to 1 when filter changes
    };


    const handleDeleteSelected = async () => {
        const content = `You are about to delete a user login. To confirm, please solve this math problem.`;
        const check = generateCaptcha(content);
        if (check) {
            try {
                const body = { id: selectedUsers };
                const response = await Calling.deleteUserLogin(body);
                if (response?.status) {
                    toast.success(response?.message);
                    setSelectedUsers([]);
                    setSelectAll(false); // Reset "Select All"
                    fetchData();
                } else {
                    toast.error(response?.message);
                }
            } catch (error) {
                console.error('Error deleting users:', error);
            } finally {
                setLoader(false);
            }
        } else {
            toast.error("Captcha answer is incorrect", { autoClose: 2000 });
        }
    };

    const handleUser = (id) => {
        navigate(`/manage/user/all/info/${id}`)
    }

    const handleReportSort = () => {
        setSelectState('sort')
        if (sortOrder === 1) {
            setSortOrder(-1)
        } else {
            setSortOrder(1)
        }
    }
    const handleSearchUser = (e) => {
        setCurrentPage(1);
        setSearch(e.target.value)
        setSelectState('search')
    }

    const handleFormDate = (e) => {
        if (e.target.name === "startDate") {
            setStartDate(e.target.value);
            setSelectState('range');
        } else {
            setEndDate(e.target.value);
            setSelectState('range');

        }
    }

    useEffect(() => {
        if (search.trim() !== '') {
            const delayDebounce = setTimeout(() => {
                fetchData();
            }, 500);

            return () => clearTimeout(delayDebounce);
        }
    }, [search]);

    return (
        <div className="w-full min-h-screen text-main-font">
            {/* Page Header */}
            <div className="mb-6">
                <div className="flex items-center gap-3">
                    <div className="p-2.5 rounded-xl bg-main-blue text-main-white">
                        <FiUsers size={24} />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-main-font">User Management</h1>
                        <p className="text-sm text-main-subfont">Manage and monitor all users</p>
                    </div>
                </div>
            </div>

            {/* Main Card */}
            <div className="bg-main-white rounded-2xl shadow-sm border border-main-border overflow-hidden">
                {/* Navigation */}
                <User_Navbar selectState={'login'} />
                <hr className="border-main-border" />

                {/* Total Users Card */}
                <div className="m-4">
                    <div className="p-5 bg-main-th rounded-xl border border-main-blue/20">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-main-subfont">Total User Logins</p>
                                <p className="text-2xl font-bold text-main-font mt-1">
                                    {loader ? (
                                        <span className="flex items-center text-main-subfont text-base">
                                            <svg className="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Loading...
                                        </span>
                                    ) : (
                                        totalUser.toLocaleString()
                                    )}
                                </p>
                            </div>
                            <div className="p-3 rounded-xl bg-main-blue/10">
                                <FiUsers size={28} className="text-main-blue" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Filters Section */}
                <div className="px-4 py-3 border-t border-main-border">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                        {/* Date Range Buttons */}
                        <div className="flex flex-wrap gap-2">
                            <MainButton onClick={() => handleDateRangeFilter('today')} label={'Today'} selectState={selectState === 'today'} />
                            <MainButton onClick={() => handleDateRangeFilter('yesterday')} label={'Yesterday'} selectState={selectState === "yesterday"} />
                            <MainButton onClick={() => handleDateRangeFilter('thisWeek')} label={'This Week'} selectState={selectState === 'thisWeek'} />
                            <MainButton onClick={() => handleDateRangeFilter('thisMonth')} label={'This Month'} selectState={selectState === 'thisMonth'} />
                            <MainButton onClick={() => handleDateRangeFilter('last6Months')} label={'Last 6 Months'} selectState={selectState === 'last6Months'} />
                            <MainButton onClick={() => handleDateRangeFilter('thisYear')} label={'This Year'} selectState={selectState === 'thisYear'} />
                        </div>

                        {/* Date Inputs */}
                        <div className="flex flex-col sm:flex-row gap-2">
                            <input
                                type="date"
                                value={startDate}
                                name="startDate"
                                onChange={handleFormDate}
                                className={`px-4 py-2 rounded-xl border cursor-pointer transition-all ${selectState === "range"
                                        ? 'border-main-blue text-main-blue bg-main-th'
                                        : 'border-main-border text-main-subfont bg-main-white'
                                    } focus:border-main-blue focus:outline-none`}
                            />
                            <input
                                type="date"
                                value={endDate}
                                name="endDate"
                                onChange={handleFormDate}
                                className={`px-4 py-2 rounded-xl border cursor-pointer transition-all ${selectState === "range"
                                        ? 'border-main-blue text-main-blue bg-main-th'
                                        : 'border-main-border text-main-subfont bg-main-white'
                                    } focus:border-main-blue focus:outline-none`}
                            />
                        </div>
                    </div>
                </div>

                {/* Action Buttons and Search */}
                <div className="px-4 py-3 border-t border-main-border">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                        {/* Action Buttons */}
                        <div className="flex flex-wrap gap-2">
                            <MainButton
                                onClick={handleReportSort}
                                label={
                                    <span className="flex items-center gap-2">
                                        {sortOrder === -1 ? <FaSortAmountDownAlt /> : <FaSortAmountUp />}
                                        Sort
                                    </span>
                                }
                                selectState={selectState === 'sort'}
                            />
                        </div>

                        {/* Search Input */}
                        <div className="relative w-full lg:w-80">
                            <IoMdSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-main-subfont" size={20} />
                            <input
                                type="search"
                                className="w-full pl-11 pr-4 py-2.5 border border-main-border rounded-xl bg-main-bg focus:bg-main-white focus:ring-2 focus:ring-main-blue/20 focus:border-main-blue focus:outline-none transition-all"
                                value={search}
                                onChange={handleSearchUser}
                                placeholder="Search logins..."
                            />
                        </div>
                    </div>
                </div>

                {/* Table */}
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr className="bg-main-th">
                                <th className="ps-4 py-4 text-left">
                                    <div className="flex items-center gap-3">
                                        <input
                                            type="checkbox"
                                            className="w-4 h-4 rounded border-main-border text-main-blue focus:ring-main-blue cursor-pointer"
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                        {selectedUsers.length > 0 && (
                                            <DeleteButton
                                                onClick={() => handleDeleteSelected()}
                                                label={<MdDeleteSweep size={20} />}
                                            />
                                        )}
                                    </div>
                                </th>
                                <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">#</th>
                                <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">Type</th>
                                <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">Login ID</th>
                                <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">Platform</th>
                                <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">Date</th>
                                <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">Action</th>
                            </tr>
                        </thead>

                        {loader ? (
                            <tbody>
                                <tr>
                                    <td colSpan={7} className="text-center py-12">
                                        <Loader />
                                    </td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody className="divide-y divide-main-border">
                                {data.length > 0 ? data.map((user, index) => (
                                    <tr key={user._id} className="hover:bg-main-thHover transition-colors">
                                        <td className="ps-4 py-4">
                                            <input
                                                type="checkbox"
                                                checked={selectedUsers.includes(user._id)}
                                                onChange={() => handleSelectUser(user._id)}
                                                className="w-4 h-4 rounded border-main-border text-main-blue focus:ring-main-blue cursor-pointer"
                                            />
                                        </td>
                                        <td className="px-4 py-4 text-sm text-main-subfont">{index + 1 + (currentPage - 1) * limit}</td>
                                        <td className="px-4 py-4">
                                            <span className={`inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-lg ${user?.l_type === 'email'
                                                    ? 'bg-orange-50 text-orange-600 border border-orange-200'
                                                    : 'bg-purple-50 text-purple-600 border border-purple-200'
                                                }`}>
                                                {user?.l_type ? user.l_type.toUpperCase() : 'DEVICE'}
                                            </span>
                                        </td>
                                        <td className="px-4 py-4">
                                            <p
                                                className="font-medium text-main-font cursor-pointer hover:text-main-blue transition-colors"
                                                onClick={() => handleUser(user?.u_info)}
                                            >
                                                {user?.l_email || user?.l_device || "N/A"}
                                            </p>
                                        </td>
                                        <td className="px-4 py-4">
                                            <span className={`inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-lg ${user?.l_platform === 'android'
                                                    ? 'bg-green-50 text-green-600 border border-green-200'
                                                    : user?.l_platform === 'ios'
                                                        ? 'bg-blue-50 text-blue-600 border border-blue-200'
                                                        : 'bg-main-bg text-main-subfont border border-main-border'
                                                }`}>
                                                {user?.l_platform ? user.l_platform.charAt(0).toUpperCase() + user.l_platform.slice(1) : 'Unknown'}
                                            </span>
                                        </td>
                                        <td className="px-4 py-4 text-sm text-main-subfont">{formatDate(user.createdAt)}</td>
                                        <td className="px-4 py-4">
                                            <button
                                                onClick={() => handleUser(user?.u_info)}
                                                className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-main-blue text-main-white hover:bg-main-blue/90 transition-colors"
                                                title="View User"
                                            >
                                                <FaUser size={14} />
                                            </button>
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={7} className="py-12">
                                            <NotFound />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>

                {/* Pagination */}
                <div className="p-6 border-t border-main-border">
                    <div className="flex flex-col md:flex-row justify-center items-center relative">
                        <div className="flex gap-3 mb-4 md:mb-0">
                            <button
                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium transition-all ${currentPage === 1
                                        ? "bg-main-bg border border-main-border text-main-subfont cursor-not-allowed"
                                        : "bg-main-blue text-main-white hover:bg-main-blue/90"
                                    }`}
                            >
                                <FaArrowLeft size={12} /> Previous
                            </button>
                            <button
                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium transition-all ${currentPage === totalPages
                                        ? "bg-main-bg border border-main-border text-main-subfont cursor-not-allowed"
                                        : "bg-main-blue text-main-white hover:bg-main-blue/90"
                                    }`}
                            >
                                Next <FaArrowRight size={12} />
                            </button>
                        </div>

                        <p className="text-main-subfont md:absolute md:right-0 text-sm">
                            Page{' '}
                            <span className="px-3 py-1.5 bg-main-th border border-main-border text-main-font font-medium rounded-lg">
                                {currentPage}
                            </span>
                            {' '}of{' '}
                            <span className="font-medium text-main-font">{totalPages}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AllUserLogin